import { disabledDate } from "../../../punonjesit/EmployeeView/Personal/EmployeesView";
import { personalNumber } from "../../../punonjesit/EmployeeView/RegEx/RegExpressions";

export default [
  {
    formItemName: "employeeFirstName",
    label: "Emri",
    placeholder: "Vendos emrin e punonjësit",
    type: "input",
    disabled: true,
  },
  {
    formItemName: "employeeFathersName",
    label: "Atësia",
    placeholder: "Vendos atësinë e punonjësit",
    type: "input",
    required: true,
  },
  {
    formItemName: "employeeLastName",
    label: "Mbiemri",
    placeholder: "Vendos mbiemrin e punonjësit",
    type: "input",
    disabled: true,
  },
  {
    formItemName: "employeePersonalNumber",
    label: "Numri personal",
    placeholder: " --- ",
    type: "input",
    rules: [
      {
        pattern: personalNumber,
        message: "Kjo fushë duhet të përmbajë vetëm numra dhe shkronja!",
      },
    ],
    required: true,
  },
  {
    formItemName: "employeeDayOfBirth",
    label: "Ditëlindja",
    placeholder: "Ditëlindja e punonjësit",
    type: "datepicker",
    format: "DD/MM/YYYY",
    onSaveFormat: "x", // will return timestamp
    disabledDate: disabledDate,
  },
  {
    formItemName: "employeePhoneNumber",
    label: "Numri i celularit",
    placeholder: "",
    type: "phone",
  },
  {
    formItemName: "employeePersonalEmail",
    label: "Email personal",
    placeholder: "Shkruaj emailin personal",
    type: "input",
  },
  {
    formItemName: "employeeAddress",
    label: "Adresa",
    placeholder: "Shkruaj adresën e punonjësit",
    type: "textarea",
  },
  {
    formItemName: "accountNumber",
    label: "Numri i llogarisë bankare",
    placeholder: "Shkruaj numrin e llogarisë",
    type: "input",
  },
];
